import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const tray = css`
  width: calc(100% - 16px);
  max-width: var(--tray-max-width);
  height: 100%;
  background: ${theme.colors.white};
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(4)};
  gap: ${theme.spacing(2)};
`;

/**
 * Anchors the tray to the bottom, adjusted by the runtime `heightOffset` (eg. desktop shell title bar),
 * provided via the `--tray-height-offset` CSS variable.
 */
export const trayAdjustedHeight = css`
  height: calc(100% - var(--tray-height-offset, 0px)) !important;
  bottom: 0 !important;
  top: auto !important;
`;

export const trayActions = css`
  display: flex;
  justify-content: space-between;
`;

export const trayActionsWithOnlyRightContent = css`
  justify-content: flex-end;
`;

export const trayActionsRightContent = css`
  display: flex;
  justify-content: end;
  gap: ${theme.spacing(3)};

  .tray-primary-button,
  .tray-secondary-button {
    width: auto;
  }
`;

export const trayBody = css`
  flex: 1;
  overflow-y: auto;
`;

export const trayHeader = css`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  position: relative;
`;

export const trayHeaderButtons = css`
  display: flex;
  gap: ${theme.spacing(1)};
`;

export const trayHeaderTitle = css`
  margin: 0;
`;
